"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "puegnago-del-garda": {
    "008dbc59": [{
      "hkey": "b6f7ceb6",
      "slug": "castello-mura",
      "name": "Castello-Mura",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "b6f7ceb6",
      "slug": "castello-mura",
      "name": "Castello-Mura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8b6f1170": [{
      "hkey": "b6f7ceb6",
      "slug": "castello-mura",
      "name": "Castello-Mura",
      "primary": true,
      "skipSearch": false
    }],
    "mura": [{
      "hkey": "b6f7ceb6",
      "slug": "castello-mura",
      "name": "Castello-Mura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "puegnago-del-garda"
    }]
  }
};
exports["default"] = _default;